import React from "react";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { View } from "@common/types/views/views";
import {
    McpConnectionColumn,
    McpConnectionRow,
    mcpConnectionsViewConfig,
} from "./mcpConnectionsViewConfig";

const defaultView: View = {
    columns: [
        { id: McpConnectionColumn.TARGET },
        { id: McpConnectionColumn.PERMISSIONS },
        { id: McpConnectionColumn.STATUS },
        { id: McpConnectionColumn.CONNECTED },
        { id: McpConnectionColumn.LAST_USED },
        { id: McpConnectionColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
    },
};

interface McpConnectionsViewProps {
    data: McpConnectionRow[];
    className?: string;
}

export const McpConnectionsView: React.FC<McpConnectionsViewProps> = ({
    data,
    className,
}) => (
    <ViewTable
        data={data}
        view={defaultView}
        config={mcpConnectionsViewConfig}
        enableColumnResizing={false}
        className={className}
    />
);
